import moment from 'moment';
import qs from 'qs';
import oikosApi from '../../../services/oikos';
import { buildContrFornDocumentosObrigatoriosPayload, buildContrFornExtendedFieldsPayload, isEquipeOrcItemById } from './contrFornExtendedFields';
import { fetchContratadoEmail } from './contrFornEmailUtils';
import { PEDIDO_COMPRA_TP_PADRAO } from '../../Template/Doc/compraCotacaoTableUtils';
import { notifyError } from '../../../utils/notify';
import {
  CONTR_FORN_STATUS_EM_APROVACAO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  buildCriarContratoDiretoCompraCotacaoInfo,
  needsContrFornApproval,
} from './contrFornApprovalRules';
import {
  persistPgtoPrazoDias,
  resolveBdroDtVencFromEvento,
} from './contrFornEntregaveisUtils';
import {
  createNfECobrancaComArquivoUnico,
  insertDocumentoVinc,
} from './contrFornNfDocumentos';

const getDescricaoParcela = (parcela, index) => (
  parcela.contrFornEvento_num || parcela.contrFornEvento_desc || (index + 1)
);

const getValorEmCentavos = (valor) => Math.round(Number(valor || 0) * 100);

export   function verificarSaldoMensalValidoStandalone(listaValoresLimites, listaParcelas) {
    for (const valorLimite of listaValoresLimites) {
      const monthRef = valorLimite.mes.slice(0, 7); // 'YYYY-MM'

      // Soma todas as parcelas do mesmo mês
      const somaParcelasMes = listaParcelas
        .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
        .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);

      // Compara
      const diferenca = Number(Number(valorLimite.disponivel).toFixed(2)) - Number(somaParcelasMes.toFixed(2));

      if (diferenca < 0) {
        return false;
      }
    }

    return true;
  }


export function verificarValorGlobalStandalone(ctx, { mostrarErro = true } = {}) {
  const {
    contrFornData = {},
    valoresLimites = [],
    resumoOrcamentoPorAno = [],
    listaParcelas = [],
  } = ctx;

  const valorGlobal = Number(Number(
    Number(contrFornData.contrForn_vlrFixo) === 0
      ? (listaParcelas || []).reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0)
      : (contrFornData.contrForn_vlrGlobal || 0),
  ).toFixed(2));

  const somaValoresLimites = Number((
    resumoOrcamentoPorAno.length > 0
      ? resumoOrcamentoPorAno.reduce(
        (acc, cur) => Number(acc) + Number(cur.valorDisponivel || 0),
        0,
      )
      : valoresLimites.reduce(
        (acc, cur) => Number(acc) + Number(cur.disponivel || 0),
        0,
      )
  ).toFixed(2));

  if (valorGlobal > somaValoresLimites) {
    if (mostrarErro) notifyError('Saldo insuficiente');
    return false;
  }
  return true;
}

export function validarVinculosBdrosStandalone(ctx, { ignorarAvisoSemBdro = false } = {}) {
  const { bdrosVinculaveis, listaParcelas, bdrosOrcItem, setIsAvisoSemBdroOpen } = ctx;
  if (bdrosVinculaveis.length === 0) return true;
  const parcelasComBdro = listaParcelas.filter((parcela) => parcela.bdro_id);
  if (parcelasComBdro.length === 0) {
    if (!ignorarAvisoSemBdro) {
      setIsAvisoSemBdroOpen(true);
      return false;
    }
    return true;
  }
  const bdrosSelecionados = new Set();
  for (let index = 0; index < listaParcelas.length; index++) {
    const parcela = listaParcelas[index];
    if (!parcela.bdro_id) continue;
    if (bdrosSelecionados.has(Number(parcela.bdro_id))) {
      notifyError(`O borderô vinculado à parcela ${getDescricaoParcela(parcela, index)} já foi selecionado em outra parcela.`);
      return false;
    }
    bdrosSelecionados.add(Number(parcela.bdro_id));
    const bdro = bdrosOrcItem.find((item) => Number(item.bdro_id) === Number(parcela.bdro_id));
    if (!bdro) continue;
    if (getValorEmCentavos(parcela.contrFornEvento_vlr) !== getValorEmCentavos(bdro.bdro_vlr)) {
      notifyError(`O valor da parcela ${getDescricaoParcela(parcela, index)} não é igual ao valor do borderô vinculado a ela.`);
      return false;
    }
  }
  return true;
}

export async function vincularBdroAParcelaStandalone(ctx, contrFornEventoId, bdroId) {
  const { user } = ctx;
  if (!contrFornEventoId || !bdroId) return;
  await oikosApi.post('/', {
    action: 'update',
    table: 'contrFornEvento',
    data: {
      contrFornEvento_id: contrFornEventoId,
      bdro_id: bdroId,
      contrFornEvento_usuarioMod: user.pf_id,
    },
  });
  await oikosApi.post('/', {
    action: 'update',
    table: 'bdro',
    data: {
      bdro_id: bdroId,
      bdro_tabRef: 'contrFornEvento',
      bdro_tabId: contrFornEventoId,
      bdro_usuarioMod: user.pf_id,
    },
  });
}

export async function submitStandaloneContrForn(ctx, { ignorarAvisoSemBdro = false, ignorarAvisoSaldoMensal = false, criarContratoParaAprovacao = false } = {}) {
  const {
    contrFornData,
    listaParcelas,
    filteredValoresLimites,
    filesContrForn,
    nfUnicaFilesContrForn,
    selOrcItems,
    selPfsFornecedor,
    selPjsFornecedor,
    user,
    trimContrFornDesc,
    saveDocuments,
    checkCamposObrigatoriosContrForn,
    checkCamposObrigatoriosParcelas,
    comparaValorGlobalComParcelas,
    verificaDocumentoContrForn,
    verificaDataVigencia,
    setIsAvisoSaldoMensalOpen,
  } = ctx;

    ctx.setLoadingSubmit(true);

    const verificaCamposObrigatoriosContrForn = checkCamposObrigatoriosContrForn();
    if (!verificaCamposObrigatoriosContrForn) return ctx.setLoadingSubmit(false);

    const verificaListaEventos = listaParcelas.length > 0;
    if (!verificaListaEventos) {
      notifyError('É necessário cadastrar pelo menos uma parcela.');
      return ctx.setLoadingSubmit(false);
    }

    const checkValorGlobal = verificarValorGlobalStandalone(ctx, { mostrarErro: false });
    if (!checkValorGlobal) {
      notifyError('O valor do contrato excede o valor disponível do item orçamentário.');
      return ctx.setLoadingSubmit(false);
    }

    const checkDocumento = verificaDocumentoContrForn();
    if (!checkDocumento) return ctx.setLoadingSubmit(false);

    const checkValorParcelas = comparaValorGlobalComParcelas();
    if (!checkValorParcelas) return ctx.setLoadingSubmit(false);

    for (let index = 0; index < listaParcelas.length; index++) {
      const parcela = listaParcelas[index];
      const check = checkCamposObrigatoriosParcelas(parcela, (index + 1))
      if (!check) {
        ctx.setLoadingSubmit(false);
        return
      };
    }

    const checkDataVigencia = verificaDataVigencia();
    if (!checkDataVigencia) return ctx.setLoadingSubmit(false);

    if (!ignorarAvisoSaldoMensal) {
      const isSaldoValido = verificarSaldoMensalValidoStandalone(filteredValoresLimites, listaParcelas);
      if (!isSaldoValido) {
        setIsAvisoSaldoMensalOpen(true);
        return ctx.setLoadingSubmit(false);
      }
    }

    if (!ignorarAvisoSemBdro) {
      const checkVinculosBdros = validarVinculosBdrosStandalone(ctx, { ignorarAvisoSemBdro });
      if (!checkVinculosBdros) return ctx.setLoadingSubmit(false);
    }

    const destinoFornecedor = criarContratoParaAprovacao
      ? null
      : await fetchContratadoEmail(
        contrFornData.contrForn_parteTab,
        contrFornData.contrForn_parteId,
      );

    if (!criarContratoParaAprovacao && !destinoFornecedor?.email) {
      notifyError(
        'O contratado não possui e-mail cadastrado (pf_emailProf ou pj_emailPrin). Cadastre o e-mail do fornecedor antes de enviar.',
      );
      return ctx.setLoadingSubmit(false);
    }

    const postBodyPedidoCompra = {
      action: 'insert',
      table: 'pedidoCompra',
      data: {
        compraStatus_id: 2,
        orcItem_id: contrFornData.orcItem_id,
        pf_id: user.pf_id,
        pedidoCompraTp_id: PEDIDO_COMPRA_TP_PADRAO,
        pedidoCompra_desc: trimContrFornDesc(),
        pedidoCompra_vlrLimite: contrFornData.contrForn_vlrGlobal,
        pedidoCompra_obs: contrFornData.contrForn_obs,
        pedidoCompra_dtSolicitacao: moment().format('YYYY-MM-DD'),
      }
    };
    const responsePedidoCompra = await oikosApi.post(`/`, postBodyPedidoCompra);
    console.log(responsePedidoCompra);

    const postBodyCompraCotacao = {
      action: 'insert',
      table: 'compraCotacao',
      data: {
        pedidoCompra_id: responsePedidoCompra.data[0].pedidoCompra_id,
        compraCotacao_vlr: contrFornData.contrForn_vlrGlobal,
        compraCotacao_parteTab: contrFornData.contrForn_parteTab,
        compraCotacao_parteId: contrFornData.contrForn_parteId,
        ...(destinoFornecedor?.email
          ? {
            compraCotacao_emailInteressado: destinoFornecedor.email,
            compraCotacao_nomeInteressado: destinoFornecedor.nome || undefined,
          }
          : {}),
        compraCotacao_desc: trimContrFornDesc(),
        compraCotacao_dtCotacao: moment().format('YYYY-MM-DD'),
        compraCotacao_obs: contrFornData.contrForn_obs,
        ...(criarContratoParaAprovacao
          ? { compraCotacao_info: buildCriarContratoDiretoCompraCotacaoInfo() }
          : {}),
      }
    };
    const responseCompraCotacao = await oikosApi.post(`/`, postBodyCompraCotacao);
    console.log(responseCompraCotacao);

    const numeroContrato = `${responsePedidoCompra.data[0].pedidoCompra_id}.${responseCompraCotacao.data[0].compraCotacao_id}/${new Date().getFullYear()}`;

    const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
    const requiresApproval = needsContrFornApproval(vlrGlobal);
    // Enviar para fornecedor: 8 se ≥10k (sem e-mail até aprovar), senão 1 + e-mail.
    // Criar contrato: 8 se ≥10k, senão 7.
    const contrFornStatusId = requiresApproval
      ? CONTR_FORN_STATUS_EM_APROVACAO
      : (criarContratoParaAprovacao ? CONTR_FORN_STATUS_EM_ASSINATURA : 1);
    const shouldSendFornecedorEmail = !criarContratoParaAprovacao && !requiresApproval;

    try {
      const postBody = {
        action: 'insert',
        table: 'contrForn',
        data: {
          orcItem_id: contrFornData.orcItem_id || undefined,
          contrForn_desc: trimContrFornDesc() || undefined,
          contrForn_num: numeroContrato,
          contrForn_detalhamento: contrFornData.contrForn_detalhamento || undefined,
          contrForn_obj: contrFornData.contrForn_obj || undefined,
          contrForn_parteTab: contrFornData.contrForn_parteTab || undefined,
          contrForn_parteId: contrFornData.contrForn_parteId || undefined,
          contrForn_dtAssin: contrFornData.contrForn_dtAssin || undefined,
          contrForn_dtVigIni: contrFornData.contrForn_dtVigIni || undefined,
          contrForn_dtVigFim: contrFornData.contrForn_dtVigFim || undefined,
          contrForn_dtRescisao: contrFornData.contrForn_dtRescisao || undefined,
          contrFornTp_id: contrFornData.contrFornTp_id || undefined,
          contrForn_vlrGlobal: contrFornData.contrForn_vlrGlobal || undefined,
          contrForn_obs: contrFornData.contrForn_obs || undefined,
          tpMinuta_id: contrFornData.tpMinuta_id || undefined,
          contrFornStatus_id: contrFornStatusId,
          contrForn_dtPgtoFixa: contrFornData.contrForn_dtPgtoFixa || undefined,
          contrForn_vlrFixo: contrFornData.contrForn_vlrFixo || undefined,
          compraCotacao_id: responseCompraCotacao.data[0].compraCotacao_id,
          pf_id: user.pf_id,
          contrForn_vlrFixo: contrFornData.contrForn_vlrFixo || 0,
          contrForn_dtPgtoFixa: contrFornData.contrForn_dtPgtoFixa || 0,
          contrForn_renovacaoAutomatica: contrFornData.contrForn_renovacaoAutomatica || 0,
          contrForn_maoObraLocal: contrFornData.contrForn_maoObraLocal || 0,
          ...buildContrFornExtendedFieldsPayload(
            contrFornData,
            isEquipeOrcItemById(selOrcItems, contrFornData.orcItem_id),
          ),
          ...buildContrFornDocumentosObrigatoriosPayload(contrFornData, true),
        }
      };
      console.log(postBody)
      let contratadoNome = '';

      const response = await oikosApi.post(`/`, postBody);

      if (contrFornData.contrForn_parteTab === 'pf') {
        const found = selPfsFornecedor.find(f => f.value === contrFornData.contrForn_parteId);
        if (found) contratadoNome = found.label;
      } else if (contrFornData.contrForn_parteTab === 'pj') {
        const found = selPjsFornecedor.find(f => f.value === contrFornData.contrForn_parteId);
        if (found) contratadoNome = found.label;
      }

      {/*
        const query = qs.stringify({
          action: 'get',
          table: 'setor',
          data: { orcRubr_id: contrFornData.centroDeCustoRubr_id },
        });

        const setores = await oikosApi.get(`/?${query}`);
        console.log('setores', setores);
        const dpto_id = setores.data[0]?.dpto_id;
        */}

        try {
          const isUmaNf = Number(contrFornData.contrForn_umaNFParaTodasAsParcela) === 1
          const nfUnicaFile = isUmaNf ? (nfUnicaFilesContrForn || [])[0] : null
          const nfUnicaDocs = nfUnicaFile
            ? await createNfECobrancaComArquivoUnico(nfUnicaFile, {
              descNf: `Nota Fiscal única ${trimContrFornDesc()}`,
              descCobranca: `Documento de cobrança ${trimContrFornDesc()}`,
            })
            : null

          const criarBdroDaParcela = async (parcela, contrFornEventoId) => {
            const bdroRes = await oikosApi.post('/', {
              action: 'insert',
              table: 'bdro',
              data: {
                bdro_vlr: Number((parcela.contrFornEvento_vlr).toFixed(2)) || 0,
                bdro_dtVenc: resolveBdroDtVencFromEvento(parcela),
                bdro_desc: `${String(parcela.contrFornEvento_desc || '').trim()} do contrato ${trimContrFornDesc()}` || undefined,
                bdro_favTab: contrFornData.contrForn_parteTab || undefined,
                bdro_favId: contrFornData.contrForn_parteId || undefined,
                orcItem_id: contrFornData.orcItem_id || undefined,
                bdro_tabRef: 'contrFornEvento',
                bdro_tabId: contrFornEventoId || undefined,
              },
            })
            const bdroId = bdroRes?.data?.[0]?.bdro_id
            if (bdroId) {
              await oikosApi.post('/', {
                action: 'update',
                table: 'contrFornEvento',
                data: {
                  contrFornEvento_id: contrFornEventoId,
                  contrFornEvento_aprovLiberado: 1,
                  bdro_id: bdroId,
                },
              })
            }
            return bdroId || null
          }

          await Promise.all((listaParcelas.map(async (parcela) => {
            const parcelaBody = {
              action: 'insert',
              table: 'contrFornEvento',
              data: {
                contrForn_id: response.data[0].contrForn_id || undefined,
                contrFornEvento_num: parcela.contrFornEvento_num || undefined,
                contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
                contrFornEvento_pgtoPrazoDias: parcela.contrFornEvento_dependeAtividade
                  ? persistPgtoPrazoDias(parcela.contrFornEvento_pgtoPrazoDias)
                  : undefined,
                contrFornEvento_dtPrev: parcela.contrFornEvento_dtPrev ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD') : undefined,
                contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
                contrFornEvento_aprovNecessita: 1,
                contrFornEvento_aprovLiberado: parcela.contrFornEvento_aprovLiberado ? 1 : 0,
                contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
                contrFornEvento_usuarioCria: user.pf_id,
                contrFornEvento_usuarioMod: user.pf_id,
                categ_id: parcela.categ_id || undefined,
                contrFornEvento_vlr: Number((parcela.contrFornEvento_vlr).toFixed(2)) || 0,
                contrFornEvento_liberacaoAutomatica: parcela.contrFornEvento_liberacaoAutomatica ? 1 : 0,
              },
            }
            const parcelaCreated = await oikosApi.post('/', parcelaBody)
            const contrFornEventoId = parcelaCreated.data[0].contrFornEvento_id
            const isLiberacaoAutomatica = Number(parcela.contrFornEvento_liberacaoAutomatica) === 1
            let bdroId = Number(parcela.bdro_id) || 0

            if (bdroId) {
              await vincularBdroAParcelaStandalone(ctx, contrFornEventoId, bdroId)
            }

            if (nfUnicaDocs?.nfId) {
              await insertDocumentoVinc({
                documentoId: nfUnicaDocs.nfId,
                tabRef: 'contrFornEvento',
                tabId: contrFornEventoId,
              })

              if (isLiberacaoAutomatica) {
                if (!bdroId) {
                  bdroId = await criarBdroDaParcela(parcela, contrFornEventoId)
                } else {
                  await oikosApi.post('/', {
                    action: 'update',
                    table: 'contrFornEvento',
                    data: {
                      contrFornEvento_id: contrFornEventoId,
                      contrFornEvento_aprovLiberado: 1,
                    },
                  })
                }
                if (bdroId) {
                  await insertDocumentoVinc({
                    documentoId: nfUnicaDocs.nfId,
                    tabRef: 'bdro',
                    tabId: bdroId,
                  })
                  await insertDocumentoVinc({
                    documentoId: nfUnicaDocs.cobrancaId,
                    tabRef: 'bdro',
                    tabId: bdroId,
                  })
                }
              }
              return
            }

            const nfParcelaFile = (parcela.contrFornEvento_nf || [])[0]
            if (isLiberacaoAutomatica && nfParcelaFile) {
              const docsParcela = await createNfECobrancaComArquivoUnico(nfParcelaFile, {
                descNf: `Nota Fiscal ${parcela.contrFornEvento_desc} ${trimContrFornDesc()}`,
                descCobranca: `Documento de cobrança ${String(parcela.contrFornEvento_desc || '').trim()} ${trimContrFornDesc()}`,
              })

              if (!bdroId) {
                bdroId = await criarBdroDaParcela(parcela, contrFornEventoId)
              } else {
                await oikosApi.post('/', {
                  action: 'update',
                  table: 'contrFornEvento',
                  data: {
                    contrFornEvento_id: contrFornEventoId,
                    contrFornEvento_aprovLiberado: 1,
                  },
                })
              }

              await insertDocumentoVinc({
                documentoId: docsParcela.nfId,
                tabRef: 'contrFornEvento',
                tabId: contrFornEventoId,
              })
              if (bdroId) {
                await insertDocumentoVinc({
                  documentoId: docsParcela.nfId,
                  tabRef: 'bdro',
                  tabId: bdroId,
                })
                await insertDocumentoVinc({
                  documentoId: docsParcela.cobrancaId,
                  tabRef: 'bdro',
                  tabId: bdroId,
                })
              }
            }
          })))
        } catch (error) {
          console.error(error)
          notifyError('Erro ao cadastrar parcelas do contrato.');
          throw error;
        }
      const savedFormDocuments = await saveDocuments(filesContrForn, response.data[0])

      if (shouldSendFornecedorEmail && ctx.buildPdfDoc && ctx.handleSendContratacaoFornecedorEmail) {
        const { doc: pdfDoc, fileName: pdfFileName } = ctx.buildPdfDoc(savedFormDocuments);
        const pdfBlob = pdfDoc.output('blob');
        const pdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });
        pdfFile.path = pdfFileName;
        const savedPdfDocuments = await saveDocuments([{ data: pdfFile }], response.data[0]);
        const compraCotacaoCriada = {
          ...(responseCompraCotacao?.data?.[0] || {}),
          pedidoCompra_id: responsePedidoCompra?.data?.[0]?.pedidoCompra_id,
          orcItem_id: contrFornData.orcItem_id,
          compraCotacao_parteTab: contrFornData.contrForn_parteTab,
          compraCotacao_parteId: contrFornData.contrForn_parteId,
          compraCotacao_emailInteressado: destinoFornecedor?.email,
          compraCotacao_nomeInteressado: destinoFornecedor?.nome || undefined,
        };

        await ctx.handleSendContratacaoFornecedorEmail(
          {
            ...contrFornData,
            ...(response.data[0] || {}),
            contrForn_parteTab: contrFornData.contrForn_parteTab,
            contrForn_parteId: contrFornData.contrForn_parteId,
            // Resposta do insert pode vir sem/null e sobrescrever o valor do form.
            contrForn_documentosObrigatorios:
              contrFornData.contrForn_documentosObrigatorios
              ?? response.data[0]?.contrForn_documentosObrigatorios,
          },
          savedPdfDocuments?.[0],
          compraCotacaoCriada,
          savedFormDocuments,
        );
      } else if ((criarContratoParaAprovacao || requiresApproval) && ctx.buildPdfDoc) {
        // ≥10k (ou Criar contrato): salva PDF para o e-mail após aprovação da task.
        const { doc: pdfDoc, fileName: pdfFileName } = ctx.buildPdfDoc(savedFormDocuments);
        const pdfBlob = pdfDoc.output('blob');
        const pdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });
        pdfFile.path = pdfFileName;
        await saveDocuments([{ data: pdfFile }], response.data[0]);
      }

      const centroDeCusto = Number(selOrcItems.filter(oi => oi.value === contrFornData.orcItem_id)[0]?.nivel2_id);
      console.log('centroDeCusto', centroDeCusto);

      // Task quando valor ≥ 10k (Enviar para fornecedor ou Criar contrato).
      if (requiresApproval && selOrcItems.length > 0) {
        const pfDestino = [13, 14].includes(centroDeCusto) ? 2 : 1;
        const postBodyTask = {
          action: 'insert',
          table: 'task',
          data: {
            task_tabRef: 'contrForn',
            task_tabId: response.data[0].contrForn_id,
            pf_id: user.pf_id,
            task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
            taskTp_id: 3,
            dpto_id: undefined,
            task_desc: `Aprovar contrato ${response.data[0].contrForn_num} ${contratadoNome}`,
            task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
            task_usuarioCria: user.pf_id
          }
        };

        const responseTask = await oikosApi.post(`/`, postBodyTask);
        await oikosApi.post(`/`, {
          ...postBodyTask,
          data: { ...postBodyTask.data, pf_id: pfDestino, task_mae: responseTask.data[0].task_id },
        });
      }

      //setIsModalProdutosOpen(false);
      await ctx.handleClickCloseModal(); if (ctx.onSuccess) await ctx.onSuccess();
    } catch (error) {
      console.error("Error creating cotação:", error);
    } finally {
      ctx.setLoadingSubmit(false);
    }
  }


export   async function preloadStandaloneOrcItem(ctx, orcItemId) {
    if (!orcItemId) return;

    ctx.setIsLoading(true);

    try {
      const resOrcItem = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        fields: {
          orcItem_id: 'value',
          item_orcamentario: 'label',
          nivel2_id: 'nivel2_id',
          nivel2: 'nivel2',
          nivel3_id: 'orcRubr_id',
          nivel3: 'orcRubr_nome',
          "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "pf_id",
          "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1)" : "pf_emailProf",
          "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)" : "projAtuacao_id"
        },
        data: {
          orcItem_id: orcItemId,
          orcItem_ativo: 1,
        },
      })}`);

      const orcItem = resOrcItem.data?.[0];

      if (!orcItem) {
        notifyError('Item orçamentário informado no link não foi encontrado.');
        return;
      }

      const centroDeCustoRubrId = orcItem.nivel2_id ? Number(orcItem.nivel2_id) : null;
      const orcRubrId = orcItem.orcRubr_id ? Number(orcItem.orcRubr_id) : null;
      const normalizedOrcItemId = Number(orcItem.value || orcItemId);
      const normalizedOrcItem = {
        ...orcItem,
        value: normalizedOrcItemId,
        nivel2_id: centroDeCustoRubrId,
        orcRubr_id: orcRubrId,
      };

      const shouldFetchByProject = centroDeCustoRubrId === 14 && orcRubrId;

      if (shouldFetchByProject) {
        await ctx.fetchProjectsForSelect();
      } else {
        ctx.setSelProjetos([]);
      }

      const fetchedOrcItems = await ctx.fetchOrcItemsForSelect(centroDeCustoRubrId, shouldFetchByProject ? orcRubrId : 0);

      ctx.setSelOrcItems(prev => {
        if (!fetchedOrcItems.some(item => Number(item.value) === normalizedOrcItemId)) {
          return [normalizedOrcItem, ...prev];
        }

        return prev.map(item => (
          Number(item.value) === normalizedOrcItemId
            ? { ...normalizedOrcItem, ...item, nivel2_id: item.nivel2_id || centroDeCustoRubrId, orcRubr_id: item.orcRubr_id || orcRubrId }
            : item
        ));
      });

      ctx.setContrFornData(prev => ({
        ...prev,
        centroDeCustoRubr_id: centroDeCustoRubrId,
        orcRubr_id: orcRubrId,
        orcItem_id: normalizedOrcItemId,
      }));

      await ctx.getOrcDots(normalizedOrcItemId);
    } catch (error) {
      console.error("Error preloading orcItem from link:", error);
      notifyError('Erro ao preencher o item orçamentário informado no link.');
    } finally {
      ctx.setIsLoading(false);
    }
  }

export const submitStandaloneeContrForn = submitStandaloneContrForn;
